import {
  TextField,
  StandardTextFieldProps,
  OutlinedTextFieldProps,
  InputAdornment,
  IconButton,
  FilledTextFieldProps
} from '@mui/material';
import React, { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextFieldComponentStyled from './text-field.component.styled';

export type TextFieldComponentProps = (
  | StandardTextFieldProps
  | OutlinedTextFieldProps
  | FilledTextFieldProps
) & {
  onTextChange?: (value: string) => void;
  onlyIntegers?: boolean;
};

const TextFieldComponent = React.forwardRef(
  (
    { fullWidth, onTextChange, onlyIntegers, type, value, ...rest }: TextFieldComponentProps,
    ref: React.Ref<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: any) => {
      event.preventDefault();
    };

    const onChangeParse = (
      e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
      if (onTextChange) {
        let inputValue: string = e.target.value;
        let minusPlace: number = -1;
        let commaPlace: number = -1;
        let commaString: string = '';
        let beforeCommaString: string = '';
        const separator: string[] = [',', '.'];

        if (type === 'number') {
          
          //if onlyIntegers prop is true, do not allow commas or dots
          if(onlyIntegers) {
            inputValue = inputValue.replace(/[,.]/g, '');
          }

          //check if the number is not '0,' then replace 0 with the next digit
          if (inputValue[0] === '0' && separator.indexOf(inputValue[1]) === -1)
            inputValue = inputValue.slice(1, inputValue.length);

          //check if minus is the first place of the inputValue
          if (inputValue.indexOf('-') === 0) minusPlace = 0;

          //replace everything else but numbers, commas and dots
          inputValue = inputValue.replace(/[^0-9.,]/g, '');
          inputValue = inputValue.replace(/,/g, '.');

          //if the number starts with minus set the minus on value's first place
          if (minusPlace === 0) inputValue = `-${inputValue}`;

          //set comma's first appeareance index
          if (inputValue.indexOf('.')) commaPlace = inputValue.indexOf('.');

          //split inputValue in two: first is a string with numbers and first comma, and the rest of inputValue
          if (commaPlace > -1) {
            commaString = inputValue.slice(commaPlace + 1, inputValue.length);
            beforeCommaString = inputValue.slice(0, commaPlace + 1);
          }
          //eliminate each comma which is extra
          commaString = commaString.replace('.', '');

          //if we don't have any comma then no comma is allowed
          if (commaPlace === -1) inputValue = inputValue.replace('.', ',');

          //if we have comma then change the inputValue with the number with one comma
          if (commaPlace > -1) inputValue = beforeCommaString + commaString;
        }
        else if (type === 'phone') {
          inputValue = inputValue.replace(/[^\d]/g, ''); // Remove non-digit characters
          //inputValue = inputValue.replace(/^(\d{4})(\d{3})(\d{3})$/, '$1 $2 $3'); // Format as 4 digits space 3 digits space 3 digits
        }
        onTextChange(inputValue);
      }
    };

    /** define the return statement bellow */
    return (
      <TextFieldComponentStyled fullWidth={fullWidth}>
        <TextField
          fullWidth={fullWidth}
          {...rest}
          type={type === 'number' ? undefined : showPassword ? 'text' : type}
          onChange={onChangeParse}
          value={type === 'number' && value === '' ? '0' : value}
          inputRef={ref}
          InputLabelProps={{
            shrink: true}
        }
          InputProps={
            type === 'password'
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }
              : {}
          }
        />            
      </TextFieldComponentStyled>
    );
  }
);

export default TextFieldComponent;
